{
  "action_add": {
    "title": "Create Project",
    "error_not_found": "Not found",
    "error_duplicate_name": "Name has already been used"
  }
}
